export default __webpack_public_path__ + "static/B0069-cdef6bd6029b95f84fa054f025b0e543.png";